import React from 'react';
import { Container, Typography, Box, Paper, Divider, List, ListItem, ListItemText } from '@mui/material';

const DeleteAccountPage = () => {
  return (
    <Container maxWidth="md" sx={{ py: 8 }}>
      <Paper elevation={0} sx={{ p: 4, borderRadius: '24px', boxShadow: '0 4px 20px rgba(0,0,0,0.05)' }}>
        <Typography variant="h3" component="h1" gutterBottom sx={{ color: 'primary.main', fontFamily: '"Playfair Display", serif', fontWeight: 700 }}>
          Eliminación de cuenta – Blüm
        </Typography>
        <Typography variant="subtitle1" color="text.secondary" paragraph>
          Esta página describe cómo puedes solicitar la eliminación de tu cuenta de Blüm y qué datos se eliminan o se conservan.
        </Typography>

        <Divider sx={{ my: 4 }} />

        <Box component="section" sx={{ mb: 4 }}>
          <Typography variant="h5" gutterBottom sx={{ fontFamily: '"Playfair Display", serif', fontWeight: 700 }}>
            1. ¿Qué es Blüm y quién es el responsable?
          </Typography>
          <Typography variant="body1" paragraph>
            Blüm es una aplicación de arreglos florales operada por Blum Art. Cuando en esta página hablamos de “nosotros”, “Blüm” o “Blum Art”, nos referimos al desarrollador y operador que aparece como responsable en la ficha de Google Play Store.
          </Typography>
        </Box>

        <Box component="section" sx={{ mb: 4 }}>
          <Typography variant="h5" gutterBottom sx={{ fontFamily: '"Playfair Display", serif', fontWeight: 700 }}>
            2. Cómo solicitar la eliminación de tu cuenta
          </Typography>
          <Typography variant="body1" paragraph>
            Actualmente la eliminación de cuenta se realiza desde la propia app móvil de Blüm. Sigue estos pasos:
          </Typography>
          <List>
            <ListItem>
              <ListItemText primary="1. Abre la app Blüm en tu dispositivo Android." />
            </ListItem>
            <ListItem>
              <ListItemText primary="2. Inicia sesión con la cuenta que deseas eliminar." />
            </ListItem>
            <ListItem>
              <ListItemText primary="3. Ve a la sección “Cuenta” o “Perfil” en el menú inferior." />
            </ListItem>
            <ListItem>
              <ListItemText primary="4. Desplázate hacia abajo y pulsa en “Eliminar mi cuenta”." />
            </ListItem>
            <ListItem>
              <ListItemText primary="5. Lee el mensaje de confirmación y confirma la eliminación." />
            </ListItem>
          </List>
          <Typography variant="body1" paragraph>
            Si no puedes acceder a la app pero necesitas eliminar tu cuenta, puedes escribirnos a{' '}
            <strong>soporte@blum-art.mx</strong> desde el correo asociado a tu cuenta solicitando la eliminación.
          </Typography>
        </Box>

        <Box component="section" sx={{ mb: 4 }}>
          <Typography variant="h5" gutterBottom sx={{ fontFamily: '"Playfair Display", serif', fontWeight: 700 }}>
            3. Datos que se eliminan
          </Typography>
          <Typography variant="body1" paragraph>
            Cuando eliminas tu cuenta de Blüm desde la app, se eliminan o se desactivan los siguientes datos vinculados a tu perfil:
          </Typography>
          <List>
            <ListItem>
              <ListItemText primary="• Credenciales de acceso de Firebase (tu usuario ya no puede iniciar sesión)." />
            </ListItem>
            <ListItem>
              <ListItemText primary="• Acceso a la sección de perfil, destinatarios y direcciones dentro de la app." />
            </ListItem>
          </List>
        </Box>

        <Box component="section" sx={{ mb: 4 }}>
          <Typography variant="h5" gutterBottom sx={{ fontFamily: '"Playfair Display", serif', fontWeight: 700 }}>
            4. Datos que se conservan y motivos
          </Typography>
          <Typography variant="body1" paragraph>
            Por motivos legales, fiscales y operativos, ciertos datos se conservan incluso después de que elimines tu cuenta:
          </Typography>
          <List>
            <ListItem>
              <ListItemText primary="• Información de pedidos ya realizados (por ejemplo, histórico de órdenes, productos, montos y datos de entrega necesarios para asegurar la entrega y cumplir obligaciones legales)." />
            </ListItem>
            <ListItem>
              <ListItemText primary="• Registros de pago asociados a proveedores externos (por ejemplo, Stripe), según sus propias políticas de retención." />
            </ListItem>
          </List>
          <Typography variant="body1" paragraph>
            Estos datos se conservan durante el tiempo necesario para cumplir con obligaciones contables y legales aplicables. Una vez transcurridos los plazos legales de retención, los datos pueden anonimizarse o eliminarse de forma definitiva.
          </Typography>
        </Box>

        <Box component="section" sx={{ mb: 4 }}>
          <Typography variant="h5" gutterBottom sx={{ fontFamily: '"Playfair Display", serif', fontWeight: 700 }}>
            5. Efectos de la eliminación de cuenta
          </Typography>
          <Typography variant="body1" paragraph>
            Después de eliminar tu cuenta:
          </Typography>
          <List>
            <ListItem>
              <ListItemText primary="• No podrás iniciar sesión nuevamente con esa cuenta en la app Blüm." />
            </ListItem>
            <ListItem>
              <ListItemText primary="• No podrás ver el historial de pedidos desde la app, aunque conservemos ciertos registros internos relacionados con pedidos ya procesados." />
            </ListItem>
          </List>
        </Box>

        <Box component="section">
          <Typography variant="h5" gutterBottom sx={{ fontFamily: '"Playfair Display", serif', fontWeight: 700 }}>
            6. Contacto
          </Typography>
          <Typography variant="body1" paragraph>
            Si tienes preguntas sobre la eliminación de cuenta o sobre esta política, puedes escribirnos a:
          </Typography>
          <Typography variant="body1">
            <strong>Email:</strong> soporte@blum-art.mx
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
};

export default DeleteAccountPage;

